import {
  get as getArticle,
  getEmailCapturePersistent,
  expireEmailCapturePersistent,
  writeEmailCapturePersitent,
  ARTICLE_EMAIL_CAPTURE_COOKIE_VALUE,
} from 'services/article'

export const SET_ARTICLE_DATA = 'SET_ARTICLE_DATA'
export const SET_ARTICLE_PROCESSING = 'SET_ARTICLE_PROCESSING'
export const SET_ARTICLE_ID = 'SET_ARTICLE_ID'
export const SET_ARTICLE_EMAIL_CAPTURE_COOKIE =
  'SET_ARTICLE_EMAIL_CAPTURE_COOKIE'
export const RESET_ARTICLE_DATA = 'RESET_ARTICLE_DATA'

export function resetArticleData () {
  return {
    type: RESET_ARTICLE_DATA,
    payload: {},
  }
}

export function setArticleData (data, processing = false) {
  return {
    type: SET_ARTICLE_DATA,
    payload: { data, processing },
  }
}

export function setArticleProcessing (value) {
  return {
    type: SET_ARTICLE_PROCESSING,
    payload: value,
  }
}

export function setArticleId (id, processing = true) {
  return {
    type: SET_ARTICLE_ID,
    payload: { id, processing },
  }
}

export function setArticleEmailCaptureCookie (value) {
  return {
    type: SET_ARTICLE_EMAIL_CAPTURE_COOKIE,
    payload: value,
  }
}

export function getArticleData (id, locale, language) {
  return function getArticleDataThunk (dispatch) {
    dispatch(setArticleId(id))
    return getArticle({ id, locale, language }).then(data => dispatch(setArticleData(data)))
  }
}

export function setArticleEmailCaptureCookiePersistent (
  value = ARTICLE_EMAIL_CAPTURE_COOKIE_VALUE,
  expires = 86400,
  uid,
  authToken,
) {
  return function setArticleEmailCaptureCookiePersistentThunk (dispatch) {
    writeEmailCapturePersitent(value, expires, uid, authToken)
    return dispatch(setArticleEmailCaptureCookie(value))
  }
}

export function expireArticleEmailCaptureCookiePersistent () {
  return function expireArticleEmailCaptureCookiePersistentThunk (dispatch) {
    expireEmailCapturePersistent()
    return dispatch(setArticleEmailCaptureCookie(null))
  }
}

export function getArticleEmailCaptureCookiePersistent () {
  return function getArticleEmailCaptureCookiePersistentThunk (dispatch) {
    dispatch(setArticleEmailCaptureCookie(getEmailCapturePersistent()))
  }
}
